// Presentation only: mobile never changes saved physics or shared layout settings.
export function mobileNodeSize(size, selected = false) {
  return Math.min(2.2, Math.max(1.2, size * .28)) + (selected ? .6 : 0);
}
export function mobileEdgeSize(selected = false) { return selected ? .85 : .35; }

export function segmentDistance(point, source, target) {
  const dx = target.x - source.x, dy = target.y - source.y;
  const t = Math.max(0, Math.min(1, ((point.x - source.x) * dx + (point.y - source.y) * dy) / (dx * dx + dy * dy || 1)));
  return Math.hypot(point.x - source.x - t * dx, point.y - source.y - t * dy);
}

// Tiny marks keep generous touch hit areas without making the drawing heavier.
export function nearestGraphTarget(point, nodes, edges) {
  let target = null, distance = 12;
  for (const node of nodes) {
    const d = Math.hypot(point.x - node.x, point.y - node.y);
    if (d < distance) { target = { node: node.id }; distance = d; }
  }
  if (target) return target;
  distance = 7;
  for (const edge of edges) {
    if (edge.hidden) continue;
    const d = segmentDistance(point, edge.source, edge.target);
    if (d < distance) { target = { edge: edge.id }; distance = d; }
  }
  return target;
}
